import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import {
  KVCameraView,
  KVCameraViewJSON,
  KVSceneSettings,
  RolodexEntryPatchJson,
} from 'types'

import { KVMessageDef } from './index'

export function getNewStartingViewMessage() {
  return {
    type: 'newStartingView',
    requiredData: ['cameraViewId'],

    callback: (json: KVCameraViewJSON, kv: KestrelViewerMessageCallbackAPI) => {
      const cameraView = KVCameraView.fromJSON(json)

      // Update Scene settings and save to rolodex
      const sceneSettings: KVSceneSettings =
        kv.kestrelModel?.data.sceneSettings ?? new KVSceneSettings()
      sceneSettings.startingView = cameraView

      // Send to Rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data: {
          sceneSettings: KVSceneSettings.toJSON(sceneSettings),
        },
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
